import React, { useEffect, useState } from 'react'

import { CalculationProps, RequiredParamsProps } from '../../types/MedicalCalculations'
import CalculationCard from './CalculationCard'
import { useAuth } from '../../context/AuthContext'

type Props = CalculationProps & {
  setChildPughScore: (childPughScore: string) => void
}

const ChildPughScore: React.FC<Props> = (props) => {
  const [data, setData] = useState<string | undefined>(undefined)
  const [requiredParams, setRequiredParams] = useState<RequiredParamsProps>({})
  const [isLoading, setIsLoading] = useState<boolean>(true)

  const { backendRequest } = useAuth()

  useEffect(() => {
    setIsLoading(true)

    const reqParamsObj = {
      chronic_liver_disease_cirrhosis: props.formData.chronic_liver_disease_cirrhosis,
      bilirubin_s: props.formData.bilirubin_s,
      albumin_s: props.formData.albumin_s,
      qt_inr: props.formData.qt_inr,
      ascites: props.formData.ascites,
      encephalopathy: props.formData.encephalopathy,
    }
    setRequiredParams(reqParamsObj)

    const allParamsPresent = Object.values(reqParamsObj).every((value) => {
      if (value === null || value === undefined || value === '') {
        return false
      }
      return true
    })

    const getData = async () => {
      if (allParamsPresent) {
        const response = await backendRequest({
          method: 'GET',
          endpoint: '/api/medical-calculations/child-pugh-score',
          requiresAuth: true,
          params: {
            chronic_liver_disease_cirrhosis: props.formData.chronic_liver_disease_cirrhosis,
            bilirubin_s: props.formData.bilirubin_s,
            albumin_s: props.formData.albumin_s,
            qt_inr: props.formData.qt_inr,
            ascites: props.formData.ascites,
            encephalopathy: props.formData.encephalopathy,
          },
        })
        return response
      } else {
        return undefined
      }
    }
    getData().then((response) => {
      if (response && response.status === 200) {
        setData(response.data)
        props.setChildPughScore(response.data)
      } else {
        setData(undefined)
      }
      setIsLoading(false)
    })
  }, [props.formData])

  return (
    <CalculationCard
      title='Child-Pugh SCORE'
      value={data}
      units=''
      requiredParams={requiredParams}
      isLoading={isLoading}
      formData={props.formData}
      setFormData={props.setFormData}
    />
  )
}

export default ChildPughScore
